import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface StatusIndicatorProps {
  status: string;
  className?: string;
  size?: "small" | "medium" | "large";
}

const sizeMap = {
  small: { width: "32px", height: "32px", fontSize: "14px" },
  medium: { width: "40px", height: "40px", fontSize: "18px" },
  large: { width: "48px", height: "48px", fontSize: "22px" },
};

export const StatusIndicator = ({
  status,
  className,
  size = "medium",
}: StatusIndicatorProps) => {
  const theme = useTheme();
  const dimensions = sizeMap[size];

  const getStatusColor = (status: string) => {
    switch (status) {
      case "S": // Scheduled - blue
        return theme.palette.info.main;
      case "O": // Open - green
        return theme.palette.charges.status.active;
      case "C": // Closed - brown
        return theme.palette.charges.chargeTypes.closed;
      case "H": // Heat - gray
        return theme.palette.grey[600];
      default:
        return theme.palette.grey[600];
    }
  };

  const letter =
    status === "S" || status === "O" || status === "C" || status === "H"
      ? status
      : "?";

  return (
    <Box
      className={className}
      sx={{
        ...dimensions,
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        fontWeight: "bold",
        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        bgcolor: getStatusColor(status),
      }}
    >
      {letter}
    </Box>
  );
};
